import AccessoryCommon from "./accessoryCommon";
import {createParentPositions} from "../../constants";

export default class ShampooShelf extends AccessoryCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'shampoo_shelf';
    this.partName = 'Shampoo Shelf';
    this.translateId = "visualizer.bathroom.accessories.shampoo_shelf";
    this.visible = true;
    this.canBeDisabled = true;
    if (isChild) {
      createParentPositions(this);
    }
  }
}
